import { Routes } from '@angular/router';
import { hubsRoutes } from './hubs/hubs.routes';
import { driversRoutes } from './drivers/drivers.routes';
import { fleetsRoutes } from './fleets/fleets.routes';
import { tripsRoutes } from './trips/trips.routes';
import { kidsRoutes } from './kids/kids.routes';
import { messagesRoutes } from './messages/messages.routes';
import { dashboardRoutes } from './dashboard/dashboard.routes';
import { scheduleRoutes } from './schedule/schedule.routes';
import { settingsRoutes } from './settings/settings.routes';
import { usersRoutes } from './users/users.routes';
import { calendarRoutes } from './calendar/calendar.routes';
import { availabilityRoutes } from './availability/availability.routes';
import { setupWizardRoutes } from './setup-wizard/setup-wizard.routes';
import { paymentsRoutes } from './payments/payments.routes';
import { planBillingRoutes } from './plan-billing/plan-billing.routes';
import { orgProfileRoutes } from './org-profile/org-profile.routes';
import { authRoutes } from './auth/auth.routes';
import { authGuard } from './guards/auth.guard';
import { v2On } from './v2/ui-v2.guard';

// Pages shared by the current app and v2. Only the shell and the home screens differ.
const sharedChildren: Routes = [
  ...dashboardRoutes,
  ...tripsRoutes,
  ...kidsRoutes,
  ...messagesRoutes,
  ...hubsRoutes,
  ...driversRoutes,
  ...fleetsRoutes,
  ...scheduleRoutes,
  ...calendarRoutes,
  ...availabilityRoutes,
  ...settingsRoutes,
  ...paymentsRoutes,
  ...planBillingRoutes,
  ...orgProfileRoutes,
  ...usersRoutes,
  ...setupWizardRoutes,
];

export const routes: Routes = [
  // Auth routes (no tab bar, no guard)
  ...authRoutes,

  // v2 app (softer look, sidebar on web / floating tab bar on phones). Matches only when the v2 switch is on
  // (see v2/ui-v2.service.ts); otherwise the router falls through to the current app below.
  {
    path: '',
    canMatch: [v2On],
    canActivate: [authGuard],
    loadComponent: () => import('./v2/shell/v2-shell.component').then(m => m.V2ShellComponent),
    children: [
      // Everything that used to land on the dashboard lands on Today.
      { path: 'dashboard', redirectTo: 'today', pathMatch: 'full' },
      { path: 'today', loadComponent: () => import('./v2/pages/today/today.page').then(m => m.TodayPage) },
      { path: 'people', loadComponent: () => import('./v2/pages/people/people.page').then(m => m.PeoplePage) },
      { path: 'more', loadComponent: () => import('./v2/pages/more/v2-more.page').then(m => m.V2MorePage) },
      { path: 'tv-displays', loadComponent: () => import('./v2/pages/tv/tv-displays-v2.page').then(m => m.TvDisplaysV2Page) },
      ...sharedChildren,
      { path: '', redirectTo: 'today', pathMatch: 'full' },
    ],
  },

  // Current app with bottom tabs (protected)
  {
    path: '',
    loadComponent: () => import('./tabs/tabs.page').then(m => m.TabsPage),
    canActivate: [authGuard],
    children: [
      ...sharedChildren,
      {
        path: 'more',
        loadComponent: () => import('./tabs/more/more.page').then(m => m.MorePage)
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
    ],
  },
];
